import {
  Calendar1Icon,
  CrmIcon,
  Grid2,
  PhoneIcon,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  UserIcon,
} from "components";
import { useFetchQuery } from "hooks/useQueries";
import { useParams } from "react-router-dom";
import { moneyCommaSeparator, numberToCurrency } from "utils";
import { CLIENT_SUMMARY_BY_ID } from "utils/apiRoutes";
import { paletteLightTheme } from "utils/ColorTheme";

interface Props {
  clientData: any;
}

const ClientCard = (props: Props) => {
  const { clientData } = props;

  const { id } = useParams();

  const { data: clientSummaryData } = useFetchQuery({
    key: ["GET_CLIENT_SUMMARY_DATA", id],
    route: CLIENT_SUMMARY_BY_ID(id),
  });

  // const { isFetching: xirrLoading, refetch: refreshXirr } = useFetchQuery({
  //   route: CLIENT_REFRESH_XIRR(id),
  //   key: ["GET_CLIENT_REFRESH"],
  //   enabled: false,
  //   success: () => {
  //     refetchQuery("GET_CLIENT_SUMMARY_DATA");
  //   },
  // });

  return (
    // <Grid2 container spacing={2}>
    //   <Grid2 size={6} container>
    //     <Grid2 size={12} display={"flex"} alignItems={"center"} gap={1}>
    //       <Typography fontWeight={600} fontSize={20}>
    //         {clientData?.personalDetails?.name}
    //       </Typography>
    //       <Typography fontWeight={500} fontSize={12}>
    //         {clientData?.clientCode}
    //       </Typography>
    //       {/* <Typography fontWeight={500} fontSize={12}>
    //         <Chip
    //           size="small"
    //           variant="outlined"
    //           label={clientData?.type}
    //           color={clientData?.type === "PMS" ? "warning" : "success"}
    //           sx={{
    //             borderRadius: "8px",
    //             color: clientData?.type === "PMS" ? "" : "",
    //           }}
    //         />
    //       </Typography> */}
    //     </Grid2>
    //     <Grid2 size={12} display={"flex"} alignItems={"center"} gap={2}>
    //       <Typography fontWeight={600} fontSize={12} minWidth={"fit-content"}>
    //         <span
    //           style={{
    //             marginRight: 8,
    //             color: "var(--neutral-500)",
    //             fontWeight: 400,
    //             fontSize: 12,
    //           }}
    //         >
    //           Family:
    //         </span>
    //         {clientData?.familyName || "-"}
    //       </Typography>
    //       <Typography fontWeight={600} fontSize={12}>
    //         <span
    //           style={{
    //             marginRight: 8,
    //             color: "var(--neutral-500)",
    //             fontWeight: 400,
    //             fontSize: 12,
    //           }}
    //         >
    //           Phone:
    //         </span>
    //         {clientData?.phone}
    //       </Typography>
    //       <Typography fontWeight={600} fontSize={12}>
    //         <span
    //           style={{
    //             marginRight: 8,
    //             color: "var(--neutral-500)",
    //             fontWeight: 400,
    //             fontSize: 12,
    //           }}
    //         >
    //           PAN:
    //         </span>
    //         {clientData?.personalDetails?.pan}
    //       </Typography>
    //     </Grid2>
    //   </Grid2>
    //   <Grid2 size={12}>
    //     <TableContainer>
    //       <Table>
    //         <TableBody>
    //           <TableRow>
    //             <TableCell
    //               sx={{
    //                 p: "16px !important",
    //                 borderBottom: "none",
    //                 borderRight: `solid 1px ${paletteLightTheme.palette.border.main}`,
    //               }}
    //               width={"20%"}
    //             >
    //               <Typography
    //                 fontWeight={400}
    //                 fontSize={12}
    //                 color={"var(--neutral-500)"}
    //               >
    //                 Net Contribution
    //               </Typography>
    //               <Typography fontWeight={600} fontSize={18}>
    //                 {numberToCurrency(clientSummaryData?.data?.netContribution)}
    //               </Typography>
    //             </TableCell>
    //             <TableCell
    //               sx={{
    //                 p: "16px !important",
    //                 borderBottom: "none",
    //                 borderRight: `solid 1px ${paletteLightTheme.palette.border.main}`,
    //               }}
    //               width={"20%"}
    //             >
    //               <Typography
    //                 fontWeight={400}
    //                 fontSize={12}
    //                 color={"var(--neutral-500)"}
    //               >
    //                 Invested Value
    //               </Typography>
    //               <Typography fontWeight={600} fontSize={18}>
    //                 {numberToCurrency(clientSummaryData?.data?.investedValue)}
    //               </Typography>
    //             </TableCell>
    //             <TableCell
    //               sx={{
    //                 p: "16px !important",
    //                 borderBottom: "none",
    //                 borderRight: `solid 1px ${paletteLightTheme.palette.border.main}`,
    //               }}
    //               width={"20%"}
    //             >
    //               <Typography
    //                 fontWeight={400}
    //                 fontSize={12}
    //                 color={"var(--neutral-500)"}
    //               >
    //                 Current Value
    //               </Typography>
    //               <Typography fontWeight={600} fontSize={18}>
    //                 {numberToCurrency(clientSummaryData?.data?.currentValue)}
    //               </Typography>
    //             </TableCell>
    //             <TableCell
    //               sx={{
    //                 p: "16px !important",
    //                 borderBottom: "none",
    //                 borderRight: `solid 1px ${paletteLightTheme.palette.border.main}`,
    //               }}
    //               width={"20%"}
    //             >
    //               <Typography
    //                 fontWeight={400}
    //                 fontSize={12}
    //                 color={"var(--neutral-500)"}
    //               >
    //                 Unrealised Gain
    //               </Typography>
    //               <span
    //                 style={{
    //                   display: "flex",
    //                   flexDirection: "row",
    //                   alignItems: "center",
    //                   gap: 4,
    //                 }}
    //               >
    //                 <Typography fontWeight={600} fontSize={18}>
    //                   {numberToCurrency(
    //                     clientSummaryData?.data?.unrealisedGain,
    //                   )}
    //                 </Typography>
    //                 <Typography
    //                   fontSize={10}
    //                   color={
    //                     clientSummaryData?.data?.absoluteReturn > 0
    //                       ? paletteLightTheme.palette.success.main
    //                       : `var(--warning-700)`
    //                   }
    //                 >
    //                   (
    //                   {moneyCommaSeparator(
    //                     clientSummaryData?.data?.absoluteReturn,
    //                   )}
    //                   % )
    //                 </Typography>
    //               </span>
    //             </TableCell>
    //             <TableCell
    //               sx={{
    //                 borderBottom: "none",
    //                 p: "16px !important",
    //               }}
    //               width={"20%"}
    //             >
    //               <Typography
    //                 fontWeight={400}
    //                 fontSize={12}
    //                 color={"var(--neutral-500)"}
    //               >
    //                 {`Today's Gain`}
    //               </Typography>
    //               <span
    //                 style={{
    //                   display: "flex",
    //                   flexDirection: "row",
    //                   alignItems: "center",
    //                   gap: 4,
    //                 }}
    //               >
    //                 <Typography fontWeight={600} fontSize={18}>
    //                   {numberToCurrency(clientSummaryData?.data?.todaysGain)}
    //                 </Typography>
    //                 <Typography
    //                   fontSize={10}
    //                   color={
    //                     clientSummaryData?.data?.todaysGainPercentage > 0
    //                       ? paletteLightTheme.palette.success.main
    //                       : `var(--warning-700)`
    //                   }
    //                 >
    //                   (
    //                   {moneyCommaSeparator(
    //                     clientSummaryData?.data?.todaysGainPercentage,
    //                   )}
    //                   % )
    //                 </Typography>
    //               </span>
    //             </TableCell>
    //           </TableRow>
    //         </TableBody>
    //       </Table>
    //     </TableContainer>
    //   </Grid2>
    //   <Grid2 size={12}>
    //     <Divider />
    //   </Grid2>
    // </Grid2>
    <Grid2 container spacing={2}>
      <Grid2
        container
        size={12}
        p={2}
        borderRadius={1}
        bgcolor={"var(--grey-bg-100)"}
      >
        <Grid2 size={4.5} container spacing={1}>
          <Grid2 size={12} display={"flex"} alignItems={"center"} gap={"4px"}>
            <UserIcon color="var(--neutral-500)" />
            <Typography
              fontWeight={500}
              color="var(--neutral-500)"
              display={"flex"}
              alignItems={"center"}
              gap={1}
            >
              Client Name / Code:
              <Typography
                fontWeight={500}
                color={"var(--black)"}
                component={"span"}
              >
                {clientData?.personalDetails?.name} - {clientData?.clientCode}
              </Typography>
            </Typography>
          </Grid2>
          <Grid2 size={12} display={"flex"} alignItems={"center"} gap={"4px"}>
            <PhoneIcon color="var(--neutral-500)" />
            <Typography
              fontWeight={500}
              color="var(--neutral-500)"
              display={"flex"}
              alignItems={"center"}
              gap={1}
            >
              Phone No:
              <Typography
                fontWeight={500}
                color={"var(--black)"}
                component={"span"}
              >
                {clientData?.phone}
              </Typography>
            </Typography>
          </Grid2>
        </Grid2>

        <Grid2
          container
          size={7.5}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"flex-end"}
          gap={2}
        >
          <Grid2
            display={"flex"}
            flexDirection={"column"}
            gap={1}
            justifyContent={"flex-end"}
          >
            <Typography
              fontWeight={500}
              color="var(--neutral-500)"
              display={"flex"}
              alignItems={"center"}
              gap={1}
            >
              <CrmIcon color="var(--neutral-500)" />
              Family Name:
              <Typography
                fontWeight={500}
                color={"var(--black)"}
                component={"span"}
                justifyContent={"flex-end"}
              >
                {clientData?.familyName || "-"}
              </Typography>
            </Typography>
            <Typography
              fontWeight={500}
              color="var(--neutral-500)"
              display={"flex"}
              alignItems={"center"}
              gap={1}
            >
              <Calendar1Icon color="var(--neutral-500)" />
              PAN:
              <Typography
                fontWeight={500}
                color={"var(--black)"}
                component={"span"}
              >
                {clientData?.personalDetails?.pan}
              </Typography>
            </Typography>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2 size={12}>
        <TableContainer>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell
                  sx={{
                    p: "16px !important",
                    borderBottom: "none",
                    borderRight: `solid 1px ${paletteLightTheme.palette.border.main}`,
                  }}
                  width={"20%"}
                >
                  <Typography
                    fontWeight={400}
                    fontSize={12}
                    color={"var(--neutral-500)"}
                  >
                    Net Contribution
                  </Typography>
                  <Typography fontWeight={600} fontSize={18}>
                    {numberToCurrency(clientSummaryData?.data?.netContribution)}
                  </Typography>
                </TableCell>
                <TableCell
                  sx={{
                    p: "16px !important",
                    borderBottom: "none",
                    borderRight: `solid 1px ${paletteLightTheme.palette.border.main}`,
                  }}
                  width={"20%"}
                >
                  <Typography
                    fontWeight={400}
                    fontSize={12}
                    color={"var(--neutral-500)"}
                  >
                    Invested Value
                  </Typography>
                  <Typography fontWeight={600} fontSize={18}>
                    {numberToCurrency(clientSummaryData?.data?.investedValue)}
                  </Typography>
                </TableCell>
                <TableCell
                  sx={{
                    p: "16px !important",
                    borderBottom: "none",
                    borderRight: `solid 1px ${paletteLightTheme.palette.border.main}`,
                  }}
                  width={"20%"}
                >
                  <Typography
                    fontWeight={400}
                    fontSize={12}
                    color={"var(--neutral-500)"}
                  >
                    Current Value
                  </Typography>
                  <Typography fontWeight={600} fontSize={18}>
                    {numberToCurrency(clientSummaryData?.data?.currentValue)}
                  </Typography>
                </TableCell>
                <TableCell
                  sx={{
                    p: "16px !important",
                    borderBottom: "none",
                    borderRight: `solid 1px ${paletteLightTheme.palette.border.main}`,
                  }}
                  width={"20%"}
                >
                  <Typography
                    fontWeight={400}
                    fontSize={12}
                    color={"var(--neutral-500)"}
                  >
                    Unrealised Gain
                  </Typography>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 4,
                    }}
                  >
                    <Typography fontWeight={600} fontSize={18}>
                      {numberToCurrency(
                        clientSummaryData?.data?.unrealisedGain,
                      )}
                    </Typography>
                    <Typography
                      fontSize={10}
                      color={
                        clientSummaryData?.data?.absoluteReturn > 0
                          ? paletteLightTheme.palette.success.main
                          : `var(--warning-700)`
                      }
                    >
                      (
                      {moneyCommaSeparator(
                        clientSummaryData?.data?.absoluteReturn,
                      )}
                      % )
                    </Typography>
                  </span>
                </TableCell>
                <TableCell
                  sx={{
                    borderBottom: "none",
                    p: "16px !important",
                  }}
                  width={"20%"}
                >
                  <Typography
                    fontWeight={400}
                    fontSize={12}
                    color={"var(--neutral-500)"}
                  >
                    {`Today's Gain`}
                  </Typography>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 4,
                    }}
                  >
                    <Typography fontWeight={600} fontSize={18}>
                      {numberToCurrency(clientSummaryData?.data?.todaysGain)}
                    </Typography>
                    <Typography
                      fontSize={10}
                      color={
                        clientSummaryData?.data?.todaysGainPercentage > 0
                          ? paletteLightTheme.palette.success.main
                          : `var(--warning-700)`
                      }
                    >
                      (
                      {moneyCommaSeparator(
                        clientSummaryData?.data?.todaysGainPercentage,
                      )}
                      % )
                    </Typography>
                  </span>
                </TableCell>
                {/* <TableCell
                  sx={{
                    p: "16px !important",
                    borderBottom: "none",
                    borderLeft: `solid 1px ${paletteLightTheme.palette.border.main}`,
                  }}
                  width={"16%"}
                >
                  <Typography
                    fontWeight={400}
                    fontSize={12}
                    color={"var(--neutral-500)"}
                  >
                    Returns
                  </Typography>
                  <Typography
                    fontWeight={600}
                    fontSize={18}
                    color="var(--black)"
                    display={"flex"}
                    alignItems={"center"}
                    gap={1}
                  >
                    {clientSummaryData?.data?.xirr || "0"}
                    <Typography
                      fontSize={12}
                      fontWeight={500}
                      color="var(--neutral-500)"
                      display="flex"
                      alignItems="center"
                      gap={1}
                      component="span"
                    >
                      (*As of{" "}
                      {clientSummaryData?.data?.lastXirrRefresh
                        ? dayjs(
                            clientSummaryData?.data?.lastXirrRefresh,
                          ).format("DD/MM/YYYY")
                        : ""}
                      )
                      <IconButton
                        sx={{ p: 0 }}
                        disabled={xirrLoading}
                        onClick={() => refreshXirr()}
                      >
                        {xirrLoading ? (
                          <CircularProgress size={13} />
                        ) : (
                          <ReloadIcon
                            width={13}
                            style={{ color: "var(--primary-900)" }}
                          />
                        )}
                      </IconButton>
                    </Typography>
                  </Typography>
                </TableCell> */}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid2>
    </Grid2>
  );
};

export default ClientCard;
